const ArrowRightMTask = ({ height = "18", width = "15" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.47559 3.59872L9.30976 8.09189C9.76257 8.62253 9.76257 9.49084 9.30976 10.0215L5.47559 14.5146"
      stroke="#585E66"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowRightMTask;
